import { useQuery } from '@tanstack/react-query';
import { Interval } from '@ui/constants/poll';
import { useDataChainId } from '@ui/hooks/datachain';
import { Address, zeroAddress } from 'viem';
import { usePublicClient } from 'wagmi';

import { getGenesisAirdrop } from '../../contract-instances/getGenesisAirdrop';

export const useGenesisAirdropUIData = (user?: Address) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: Interval.SLOW,
    // staleTime: 0,
    queryKey: ['useGenesisAirdropUIData', user, chainId, client?.uid],
    queryFn: async () => {
      if (!client) throw 'client not found';

      const contract = getGenesisAirdrop({
        chainId,
        publicClient: client,
      });
      const result = await contract.read.getUIData([user || zeroAddress]);
      
return {
        ...result,
      };
    },
    enabled: !!client,
  });
};
